// 账户面板 - 集成持仓/任务/道具/事件
import { useEffect, useState } from 'react';
import { Row, Col, Button, Tag, App as AntApp, Drawer, Tabs } from 'antd';
import { useStore } from '../store/account';
import { DAILY_SIGNIN_BONUS } from '../../shared/constants';
import PositionsPanel from './PositionsPanel';
import TasksPanel from './TasksPanel';
import ItemsPanel from './ItemsPanel';
import HeigeHistory from './HeigeHistory';
export default function AccountPanel() {
  const { account, loadAccount, signin, reset, refreshAccount } = useStore();
  const { modal, message } = AntApp.useApp();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerTab, setDrawerTab] = useState<'positions' | 'tasks' | 'items' | 'heige'>(
    'positions'
  );
  useEffect(() => {
    loadAccount();
  }, [loadAccount]);
  if (!account) {
    return <div className="hg-panel">加载中...</div>;
  }
  const total = account.cash + account.marketValue;
  return (
    <div className="hg-panel">
      {' '}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
        }}
      >
        {' '}
        <div>
          {' '}
          <span style={{ fontSize: 14, fontWeight: 600 }}>💰 账户</span>{' '}
          <Tag color="warning" style={{ marginLeft: 12 }}>
            {' '}
            娱乐账户 · 虚拟资金{' '}
          </Tag>{' '}
        </div>{' '}
        <div>
          {' '}
          {!account.signedToday ? (
            <Button
              type="primary"
              onClick={async () => {
                await signin();
                message.success(`签到成功 +${DAILY_SIGNIN_BONUS.toLocaleString()}`);
              }}
            >
              {' '}
              每日签到 +{DAILY_SIGNIN_BONUS.toLocaleString()}{' '}
            </Button>
          ) : (
            <Tag color="success">今日已签到</Tag>
          )}{' '}
          <Button
            type="text"
            size="small"
            danger
            style={{ marginLeft: 8 }}
            onClick={() => {
              modal.confirm({
                title: '重置账户？',
                content: '所有数据将清空，回到 500 万启动金。',
                okText: '确认重置',
                okButtonProps: { danger: true },
                onOk: async () => {
                  await reset();
                  message.success('已重置');
                },
              });
            }}
          >
            {' '}
            重置{' '}
          </Button>{' '}
        </div>{' '}
      </div>{' '}
      <Row gutter={16}>
        {' '}
        <Col span={6}>
          {' '}
          <div className="hg-metric">
            {' '}
            <div className="hg-metric-label">总资产</div>{' '}
            <div className="hg-metric-value">{total.toLocaleString()}</div>{' '}
          </div>{' '}
        </Col>{' '}
        <Col span={6}>
          {' '}
          <div className="hg-metric">
            {' '}
            <div className="hg-metric-label">可用现金</div>{' '}
            <div className="hg-metric-value">{account.cash.toLocaleString()}</div>{' '}
          </div>{' '}
        </Col>{' '}
        <Col span={6}>
          {' '}
          <div
            className="hg-metric"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setDrawerTab('positions');
              setDrawerOpen(true);
            }}
            title="点击查看持仓明细"
          >
            {' '}
            <div className="hg-metric-label">
              {' '}
              持仓市值 <span style={{ fontSize: 10, color: '#8b949e' }}>查看 →</span>{' '}
            </div>{' '}
            <div className="hg-metric-value">{account.marketValue.toLocaleString()}</div>{' '}
          </div>{' '}
        </Col>{' '}
        <Col span={6}>
          {' '}
          <div
            className="hg-metric"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setDrawerTab('tasks');
              setDrawerOpen(true);
            }}
            title="点击查看任务详情"
          >
            {' '}
            <div className="hg-metric-label">
              {' '}
              今日任务 <span style={{ fontSize: 10, color: '#8b949e' }}>查看 →</span>{' '}
            </div>{' '}
            <div className="hg-metric-value" style={{ fontSize: 18 }}>
              {' '}
              {account.signedToday ? '✅' : '⭕'} {account.task1CountToday}/1{' '}
            </div>{' '}
          </div>{' '}
        </Col>{' '}
      </Row>{' '}
      <Drawer
        title={
          drawerTab === 'positions'
            ? '📦 持仓明细'
            : drawerTab === 'tasks'
              ? '🎯 今日任务'
              : drawerTab === 'items'
                ? '🛡️ 道具商店'
                : '🏴‍☠️ 黑哥们记录'
        }
        placement="right"
        width={560}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        styles={{ body: { padding: 0 } }}
        extra={
          <Button size="small" onClick={() => refreshAccount()}>
            {' '}
            刷新{' '}
          </Button>
        }
      >
        {' '}
        <Tabs
          activeKey={drawerTab}
          onChange={(k) => setDrawerTab(k as any)}
          items={[
            { key: 'positions', label: '持仓', children: <PositionsPanel /> },
            { key: 'tasks', label: '任务', children: <TasksPanel /> },
            { key: 'items', label: '道具', children: <ItemsPanel /> },
            { key: 'heige', label: '黑哥们', children: <HeigeHistory /> },
          ]}
        />{' '}
      </Drawer>{' '}
    </div>
  );
}
